import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';

import { academiaPlans } from '../../../../data/landinaPages/academiaLanding';
import { scrollToForm } from '../../../../helpers/landingPagesHelpers';
import withComponentName from '../../../../decorators/withComponentName';

import Styles from '../styles.module.scss';
import { faPercent } from '@fortawesome/pro-light-svg-icons/faPercent';

const AcademiaPlansSection = () => (
  <section className={Styles['academia-plans-section']}>
    <div className={Styles['section-wrapper']}>
      <div className={Styles['section-head']}>
        <h2 className={Styles['section-title']}>One platform — many forms</h2>
        <p className={Styles.description}>Choose the solution that works for you</p>
      </div>
      <ul>
        {academiaPlans.map((planItem) => (
          <li key={planItem.id}>
            <h3>
              <FontAwesomeIcon icon={planItem.planIcon} />
              {planItem.plandHeading}
            </h3>
            <p className={Styles.description}>
              {planItem.planDescription}
            </p>
            {!planItem.comingSoon ? (
              <Link to={planItem.link}>
                {planItem.linkText}
                <FontAwesomeIcon icon={faChevronRight} />
              </Link>
            ) : (
              <div className={Styles['coming-soon']}>Coming Soon</div>
            )}
          </li>
        ))}
      </ul>
      <div className={Styles.divider} />
      <div className={Styles['academia-plans-offer']}>
        <div className="d-flex align-items-center">
          <FontAwesomeIcon icon={faPercent} />
          <div className={Styles['offers-divider']} />
        </div>
        <div>
          <span>
            Students, professors, educational institutions,
            and non-profit organisations receive up to 50% off.
            {' '}
          </span>
          <a onClick={scrollToForm}>Contact Us </a>
          <span> for details.</span>
        </div>
      </div>
    </div>
  </section>
);

export default withComponentName(AcademiaPlansSection);
